var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-card",
    [
      _c(
        "gg-toolbar",
        {
          on: {
            close: _vm.closeModal
          }
        },
        [_vm._v(" Delete filter ")]
      ),
      _c("v-card-text", [
        _vm._v(
          " Are you sure you wish to delete the “" +
            _vm._s(_vm.filtername) +
            "” filter? "
        )
      ]),
      _c(
        "v-card-actions",
        [
          _c(
            "gg-btn",
            {
              attrs: {
                color: "primary",
                tile: "",
                elevation: "0",
                disabled: _vm.loading,
                loading: _vm.loading
              },
              on: {
                click: _vm.removeFilter
              }
            },
            [_vm._v(" Delete ")]
          ),
          _c(
            "gg-btn",
            {
              attrs: {
                color: "primary",
                text: "text"
              },
              on: {
                click: _vm.closeModal
              }
            },
            [_vm._v(" Close ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }